export enum NotificationTypes {
  'ERROR',
  'SUCCESS',
  'INFO',
  'WARNING',
}

export interface INotification {
  type: NotificationTypes;
  title: string;
  body: string;
}
